export default __webpack_public_path__ + "static/fa-brands-400-2f517e09eb2ca6650ff5bec5a95157ab.svg";